/* eslint-disable no-console */
import { SimpleNavbar } from '@lendi/navbar';
import Head from 'next/head';
import React from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { ErrorSource, RawError } from '@datadog/browser-core';
import { AUSSIE_IS_SCRIPTS, LENDI_IS_SCRIPTS } from '@lendi-ui/scripts';
import Theme from '@lendi-ui/theme';
import { SessionProvider, Session, Type } from '@lendi/lala-react';
import { GridWrapper, Root } from './index.style';
import { getEnv } from '../utils';
import { Brand } from '@lendi/lala-react';
import { getBrandFromHostname } from '@lendi/lala-utils';
import LaunchDarklyConsumer from '../utils/launchdarkly';
import { withLDProvider } from 'launchdarkly-react-client-sdk';

datadogRum.init({
  applicationId: '726016d2-6248-4fa3-9217-427b68d6a8f1',
  clientToken: 'pub8cafc217735669ead033e5c187e5c12c',
  site: 'datadoghq.com',
  service: 'stamp-duty-calculator',
  env: getEnv(),
  sampleRate: 100,
  trackInteractions: true,
});

const session = new Session({
  brand: getBrandFromHostname(),
  type: Type.Customer,
  environment: getEnv(),
});

const getBrandTitle = (session: Session) => {
  return session.brand === Brand.Aussie ? 'Aussie' : 'Lendi';
};

interface LayoutProps {
  title?: string;
}

export const Layout: React.FC<LayoutProps> = ({ children, title }) => {
  if (typeof window === 'undefined') return null;

  const handleLogout = () => {
    session.logout();
  };

  return (
    <SessionProvider session={session}>
      <LaunchDarklyConsumer>
        <Theme name={session.brand}>
          <Head>
            <title>
              {title || 'Stamp duty calculator'} - {getBrandTitle(session)}
            </title>
            {session.brand === Brand.Lendi
              ? LENDI_IS_SCRIPTS[session.environment]
              : AUSSIE_IS_SCRIPTS[session.environment]}
          </Head>
          <Root>
            <SimpleNavbar
              homeURL="/"
              showContinueAction={false}
              showTalkToExpertCta={true}
              showBookanAppointmentCta={true}
              onException={(error) => {
                ((error as unknown) as RawError).source = ErrorSource.SOURCE;
                datadogRum.addError(error);
              }}
              onLogout={handleLogout}
            />
            <GridWrapper>{children}</GridWrapper>
          </Root>
        </Theme>
      </LaunchDarklyConsumer>
    </SessionProvider>
  );
};

export default withLDProvider({ clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID || '' })(Layout);
